import { Action } from '@ngrx/store';
import * as ReportsTypes from './reports.types'
// import { Role, Permission } from './reports.interface';

export class CreateReportRequest implements Action {
    readonly type = ReportsTypes.CREATE_REPORT_REQUEST;
    constructor(public payload: any = {}) { }
}


export class CreateReportSuccess implements Action {
    readonly type = ReportsTypes.CREATE_REPORT_SUCCESS;
    constructor(public blob: Blob, public payload: any) { }
}


export class CreateReportFailure implements Action {
    readonly type = ReportsTypes.CREATE_REPORT_FAILURE;
    constructor(public payload: any) { }
}


// Common

export class UpdateField implements Action {
    readonly type = ReportsTypes.UPDATE_FIELD;
    public constructor(public field: string, public value: any, public path: string) { }
}

export class SetDefaultData implements Action {
    readonly type = ReportsTypes.SET_DEFAULT_DATA;
    public constructor(public path: string) { }
}


export type Actions =
    CreateReportSuccess | CreateReportFailure | CreateReportRequest |

    SetDefaultData | UpdateField;
